var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom"},[_vm._v("\n   ©2017-"+_vm._s(this.timestamp)),_c('span',{staticClass:"bottom-span"},[_vm._v("iblocktech.com")]),_vm._v(" 版权所有 "),_c('b-link',{staticClass:"beian",attrs:{"target":"_blank","href":"http://www.miitbeian.gov.cn"}},[_vm._v("粤ICP备18132030号-2")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76f8aa35","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/assembly/Bottom.vue
// module id = null
// module chunks = 